module.exports = __webpack_public_path__ + "static/media/10.bfd5b7fb.jpg";